// Typelizer digest 399eaaaeea2a6648832479cf233e0a52
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** POST /c/:company_id/ledger/questions/:question_id/messages */
  create: (
    params: { questionId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/ledger/questions/:question_id/messages', params, options),
    method: 'post',
  }),
}
